import Logo from '~/assets/logo.png';
const LogoBlock = () => {
    return (
        <div className='w-auto flex items-center justify-start'>
            <img className='w-auto h-8' src={Logo} alt='logo' />
            <span className='ml-2 font-sans font-light'>
                AI Perfect Assistant
            </span>
        </div>
    );
};

export default LogoBlock;
